/**
 * Nusa Wear Modesty — Sticky ATC mobile
 * Observe le bouton ATC principal et affiche la barre sticky
 * quand il sort du viewport.
 */
(function () {
  'use strict';

  const bar = document.getElementById('nusa-sticky-atc');
  if (!bar) return;

  // Cible : le bouton ATC principal de Dawn
  const mainForm = document.querySelector('[id^="product-form-"]');
  if (!mainForm) return;

  const mainBtn = mainForm.querySelector('[name="add"]');
  if (!mainBtn) return;

  // IntersectionObserver — plus performant qu'un scroll listener
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          bar.classList.remove('nusa-sticky-atc--visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('nusa-sticky-atc--visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    },
    { rootMargin: '0px', threshold: 0 }
  );

  observer.observe(mainBtn);

  // Sync variant — quand Dawn change le variant, on met à jour
  // le select + l'input hidden de la sticky bar
  const stickyVariantId = bar.querySelector('[data-nusa-sticky-variant-id]');
  const stickyVariantSelect = bar.querySelector('[data-nusa-sticky-variant-select]');
  const stickyBtn = bar.querySelector('.nusa-sticky-atc__button');
  const stickyPrice = bar.querySelector('.nusa-sticky-atc__price-current');

  if (!stickyVariantId) return;

  // Écouter les changements sur le form principal
  mainForm.addEventListener('change', () => {
    const selectedInput = mainForm.querySelector('[name="id"]');
    if (!selectedInput) return;

    const variantId = selectedInput.value;
    stickyVariantId.value = variantId;

    if (stickyVariantSelect) {
      stickyVariantSelect.value = variantId;
    }

    // Trouver le variant dans les options pour mettre à jour prix + état
    const option = stickyVariantSelect
      ? stickyVariantSelect.querySelector(`option[value="${variantId}"]`)
      : null;

    if (stickyBtn) {
      stickyBtn.disabled = option ? option.disabled : false;
    }
  });

  // Sync depuis la sticky bar vers le form principal
  if (stickyVariantSelect) {
    stickyVariantSelect.addEventListener('change', (e) => {
      const mainSelect = mainForm.querySelector('select[name="id"]');
      if (mainSelect) {
        mainSelect.value = e.target.value;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      stickyVariantId.value = e.target.value;
    });
  }
})();
